<template>
<div>
  <vue-headful :title="site_title" />
  <div class="warnings_page">
    <template v-if="response && response.error == null">
      <div style="width: calc((100% - 98vw) + 100%)">
        <div class="awards_drag" style="width: calc(100%-20px); min-width: 618px;">
          Журнал предупреждений пользователя: {{response.name}}
        </div>
        <template v-if="response.warnings.length > 0">
          <table>
            <th>Предупреждения изменены</th>
            <th>Причина</th>
            <template v-for="warning in response.warnings">
              <tr>
                <td><a :href="'index.php?showuser=' + warning.wlog_addedby" target="_blank"><b>{{htmlDecode(warning.name)}}</b></a></td>
                <td>Дата поощрения/наказания <b>{{$options.filters.formatRusDateShort(warning.wlog_date)}} в {{$options.filters.formatDateHours(warning.wlog_date)}}</b></td>
              </tr>
              <tr>
                <td style="vertical-align:top">
                  <template v-if="warning.wlog_type == 'pos'">
                    <span class="warning_rem">Понижение уровня предупреждений</span>
                  </template>
                  <template v-else>
                    <span class="warning_add">Повышение уровня предупреждений</span>
                  </template>
                </td>
                <td style="vertical-align:top"><span v-html="getWarningText(warning.wlog_notes)"></span></td>
              </tr>
            </template>
          </table>
        </template>
        <template v-else><br>Предупреждений нет</template>
      </div>
    </template>
    <template v-else-if="response && response.error != null">
      {{response.error}}
    </template>
  </div>
</div>
</template>

<script>
export default {
  components: {},
  data: function() {
    return {
      response: null
    }
  },
  async created() {
    console.time("PageLoadTime");
    let dateEarly = new Date();
    let memberId = 0;
    if (this.$route.query.mid) {
      memberId = this.$route.query.mid;
    }
    let response = await fetch(this.getNodePath() + 'misc/warnings/' + memberId);
    let dateLater = new Date();
    this.response = await response.json();
    this.loadTime = this.spanSeconds(dateEarly, dateLater);
    console.timeEnd("PageLoadTime");
  },
  methods: {
    getWarningText(value) {
      const regExp = /<content>(.*)<\/content>/s;
      const match = value.match(regExp);
      if (match.length < 2)
        return "";
      let txt = match[1];
      // replaces [post=123]text[/post] to <a href="index.php?view=findpost&p=123">text</a>
      txt = txt.replace(/\[post=(\d+)\](.+?)\[\/post\]/gi, "<a href=\"index.php?view=findpost&p=$1\" target=\"_blank\">$2</a>");
      return txt;
    }
  }
}
</script>

<style lang="scss">
.bullshit_width {
    width: calc((100% - 100vw) + 100%); // chrome
}
@-moz-document url-prefix() {
    .bullshit_width {
        width: calc((100% - 100vw)/1.9 + 100%); // mozilla
    }
}
.warnings_page {
    th {
        font-size: 11px;
        letter-spacing: 1px;
        text-align: left;
        padding: 5px 3px;
        background-color: #2d4150;
    }
    td {
        padding: 5px 3px;
        width: 100%;
        min-width: 371px;
        background-color: #1e2c38;
    }
    td:first-child {
        min-width: 250px;
        width: 250px;
        max-width: 250px;
    }
}
.warning_add {
    font-weight: bold;
    color: red;
}
.warning_rem {
    font-weight: bold;
    color: green;
}
</style>
